module.exports = __webpack_public_path__ + "static/media/icon_box_arrow_right.defe780a.svg";